import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import BonusXLoading from "../../../../legacy/components/BonusXLoading";
import { useExternalLoginGuard } from "../hooks/useExternalLoginGuard";

interface ExternalLoginGuardProps {
  readonly children: ReactNode;
}

const forceDefaultBackNavigationState = {
  isDirectAccess: true,
};

export function ExternalLoginGuard(props: ExternalLoginGuardProps): JSX.Element {
  const { children } = props;
  const { loading, redirectTo, error } = useExternalLoginGuard();

  if (error !== null) {
    throw error;
  }

  if (loading) {
    return <BonusXLoading />;
  }

  if (redirectTo !== null) {
    return <Navigate to={redirectTo} replace state={forceDefaultBackNavigationState} />;
  }

  return <>{children}</>;
}

export default ExternalLoginGuard;
